import classNames from 'classnames';

import CenteredContent from 'components/CenteredContent';

import type { TextInBoxDesignProps } from './types';

import useBoxStyles from './Box/styles';
import useStyles from './styles';

function TextInBoxDesignFallback({ narrow }: TextInBoxDesignProps) {
  const styles = useStyles();
  const boxStyles = useBoxStyles();

  return (
    <div className={styles.root}>
      <CenteredContent appLayout={narrow}>
        <div className={classNames(styles.titleHolder, styles.titleSkeleton)}>
          <i className="skeleton" />
        </div>
        <div className={styles.grid}>
          <div className={classNames(boxStyles.wrapper, styles.boxSkeleton, 'first')}>
            <i className="skeleton" />
          </div>
          <div className={classNames(boxStyles.wrapper, styles.boxSkeleton, 'second')}>
            <i className="skeleton" />
          </div>
          <div className={classNames(boxStyles.wrapper, styles.boxSkeleton, 'third')}>
            <i className="skeleton" />
          </div>
          <div className={classNames(boxStyles.wrapper, styles.boxSkeleton, 'forth')}>
            <i className="skeleton" />
          </div>
        </div>
      </CenteredContent>
    </div>
  );
}

export default TextInBoxDesignFallback;
